// Mittlere VIDEO-Spalte: Studio-Feed 16:9. Prop-getrieben (track) — attached intern wie CamTile,
// Reconnect-Overlay via track.muted/mute/unmute, Platzhalter wenn kein Track. Ersetzt die zuvor in
// Speaker/Guest duplizierte inline-<video>+Placeholder-Logik.
import { useEffect, useRef, useState } from 'react';
import styles from './VideoStage.module.css';

export function VideoStage({ track, placeholder = 'No Video Stream from Studio' }: {
  track: MediaStreamTrack | null;
  placeholder?: string;
}) {
  const ref = useRef<HTMLVideoElement | null>(null);
  const [stalled, setStalled] = useState(false);

  useEffect(() => {
    const v = ref.current;
    if (!v || !track) return;
    v.srcObject = new MediaStream([track]);
    v.muted = true;
    void v.play().catch(() => { /* autoplay-gate */ });
    setStalled(track.muted);
    const onMute = () => setStalled(true);
    const onUnmute = () => setStalled(false);
    track.addEventListener('mute', onMute);
    track.addEventListener('unmute', onUnmute);
    return () => { track.removeEventListener('mute', onMute); track.removeEventListener('unmute', onUnmute); };
  }, [track]);

  if (!track) {
    return <div className={styles.stage}><div className={styles.placeholder}>{placeholder}</div></div>;
  }
  return (
    <div className={styles.stage}>
      <video ref={ref} className={styles.video} playsInline muted />
      {stalled && <div className={styles.overlay}><div className={styles.spinner} />reconnecting…</div>}
    </div>
  );
}
